module.exports = __webpack_public_path__ + "img/bg.451f5589.png";